import { CreateCluster, CreateDescription, CreateHeadline, CREATE_CLUSTER, CREATE_DESCRIPTION, CREATE_HEADLINE, GetAllClusters, GetArticleDescription, GetArticleHeadline, GetBrand, GetClusterDetails, GetCreateAdAds, GetCreateAdCampaign, GetCreateAdGroup, GetDescription, GetElementLogs, GetGPT3Reference, GetHeadline, GetPublishClusters, GetPublishedClusterDetails, GET_ALL_CLUSTER, GET_ARTICLE_DESCRIPTION, GET_ARTICLE_HEADLINE, GET_BRAND, GET_CLUSTER_DETAILS, GET_CREATEAD_ADS, GET_CREATEAD_CAMPAIGN, GET_CREATEAD_GROUP, GET_DESCRIPTION, GET_ELEMENT_LOGS,GET_CLUSTER_LOGS, GET_GPT3_REFERENCE, GET_HEADLINE, GET_PUBLISHED_CLUSTER_DETAILS, GET_PUBLISH_CLUSTER, PublishClusterData, PUBLISH_CLUSTER_DATA, SetActiveClusterStep, SetBrand, SetClusterDetails, SetClusterKeywords, SetClusterLoader, SetClusterName, SetClusters, SetClusterSpinner, SetClusterTable, SetCreateAdAdGroup, SetCreateAdAds, SetCreateAdCampaign, SetCreateAdDesc, SetCreateAdHeadline, SetCreateDescParam, SetCreateGroupForm, SetCreateHeadlineParam, SetCreativeReplacement, SetDescLoader, SetDescriptionID, SetEditCluster, SetGetDetails, SetGroupsLoader, SetHeaderLoader, SetHeadlineID, SetKeyWordsFile, SetLoadHeadLineDesc, SetPinningPositions, SetPublishCluster, SetSaveCluster, SetSelectedTabIndex, SetShowDrawer, SetTargetKeyword, SetTimer, SET_ACTIVE_CLUSTER_STEP, SET_BRAND, SET_CLUSTERS, SET_CLUSTER_DETAILS, SET_CLUSTER_KEYWORDS, SET_CLUSTER_LOADER, SET_CLUSTER_NAME, SET_CLUSTER_SPINNER, SET_CLUSTER_TABLE, SET_CREATEAD_ADS, SET_CREATEAD_CAMPAIGN, SET_CREATEAD_GROUP, SET_CREATE_AD_DESC, SET_CREATE_AD_HEADLINE, SET_CREATE_DESC_PARAM, SET_CREATE_GROUP_FORM, SET_CREATE_HEADLINE_PARAM, SET_CREATIVE_REPLACEMENT, SET_DESCRIPTION_ID, SET_DESC_LOADER, SET_EDIT_CLUSTER, SET_GET_DETAILS, SET_GROUPS_LOADER, SET_HEADER_LOADER, SET_HEADLINE_ID, SET_KEYWORD_FILE, SET_LOAD_HEADLINE_DESC, SET_PINNING_POSITIONS, SET_PUBLISH_CLUSTER, SET_SAVE_CLUSTER, SET_SELECTED_TAB_INDEX, SET_SHOW_DRAWER, SET_TARGET_KEYWORD, SET_TIMER, UpdateAdRotation, UpdateCreativeReplacement, UpdateGPT3Reference, UpdatePublishedCluster, UPDATE_AD_ROTATION, UPDATE_CREATIVE_REPLACEMENT, UPDATE_GPT3_REFERENCE, UPDATE_PUBLISHED_CLUSTER, GetClusterLogs, SetCreateHeadlineError, CREATE_HEADLINE_ERROR, SetCreateDescError, CREATE_DESCRIPTION_ERROR, SetGenerateHeadlineTimestamp, GENERATE_HEADLINE_TIMESTAMP, SetGenerateDescriptionTimeStamp, GENERATE_DESCRIPTION_TIMESTAMP, GSAI_DROPDOWN_DISABLED, SetGSAIDropdownDisabled } from "../types/cluster";

export const setCreateAdCampaign = (payload: any): SetCreateAdCampaign => ({
    type: SET_CREATEAD_CAMPAIGN,
    payload,
});

export const getCreateAdCampaign = (
    payload: { accountID: any, user: any },
    callback: Function
): GetCreateAdCampaign => ({
    type: GET_CREATEAD_CAMPAIGN,
    payload,
    callback,
});

export const setClusterSpinner = (payload: boolean): SetClusterSpinner => ({
    type: SET_CLUSTER_SPINNER,
    payload,
});

export const setSelectedTabIndex = (payload: number): SetSelectedTabIndex => ({
    type: SET_SELECTED_TAB_INDEX,
    payload,
});

export const getCreateAdGroup = (
    payload: { accountID: any, campaignId: any, user: any },
    callback: Function
): GetCreateAdGroup => ({
    type: GET_CREATEAD_GROUP,
    payload,
    callback,
});

export const getCreateAdAds = (
    payload: { accountID: any, campaignId:any, adGroupId: any, user: any },
    callback: Function
): GetCreateAdAds => ({
    type: GET_CREATEAD_ADS,
    payload,
    callback,
});

export const createCluster = (
    payload: { accountID: any, file: any, user: any },
    callback: Function
): CreateCluster => ({
    type: CREATE_CLUSTER,
    payload,
    callback,
});

export const getAllClusters = (
    payload: { accountID: any, user: any },
    callback: Function
): GetAllClusters => ({
    type: GET_ALL_CLUSTER,
    payload,
    callback,
});

export const getBrand = (
    payload: { accountID: any, user: any },
    callback: Function
): GetBrand => ({
    type: GET_BRAND,
    payload,
    callback,
});

export const getGPT3Reference = (
    payload: { platformId: any, brandId: any, accountID: any, user: any },
    callback: Function
): GetGPT3Reference => ({
    type: GET_GPT3_REFERENCE,
    payload,
    callback,
});

export const updateGPT3Reference = (
    payload: { accountID: any, params: any, user: any },
    callback: Function
): UpdateGPT3Reference => ({
    type: UPDATE_GPT3_REFERENCE,
    payload,
    callback,
});

export const getArticleHeadline = (
    payload: { brandId: any, platformId: any, accountID: any, user: any },
    callback: Function
): GetArticleHeadline => ({
    type: GET_ARTICLE_HEADLINE,
    payload,
    callback,
});

export const getArticleDescription = (
    payload: { brandId: any, platformId: any, accountID: any, user: any },
    callback: Function
): GetArticleDescription => ({
    type: GET_ARTICLE_DESCRIPTION,
    payload,
    callback,
});

export const createHeadline = (
    payload: { accountID: any, params: any, clusterID: string, user: any },
    callback: Function
): CreateHeadline => ({
    type: CREATE_HEADLINE,
    payload,
    callback,
});

export const createDescription = (
    payload: { accountID: any, params: any, clusterID: string, user: any },
    callback: Function
): CreateDescription => ({
    type: CREATE_DESCRIPTION,
    payload,
    callback,
});

export const getHeadline = (
    payload: { accountID: any, headlineId: any, clusterID: string, user: any },
    callback?: Function
): GetHeadline => ({
    type: GET_HEADLINE,
    payload,
    callback,
});

export const getDescription = (
    payload: { accountID: any, descriptionId: any, clusterID: string, user: any },
    callback?: Function
): GetDescription => ({
    type: GET_DESCRIPTION,
    payload,
    callback,
});

export const getElementLogs = (
    payload: { elementId: any, user:any },
    callback?: Function
): GetElementLogs => ({
    type: GET_ELEMENT_LOGS,
    payload,
    callback,
});

export const getClusterLogs = (
    payload: { publishClusterId: any, user:any },
    callback?: Function
): GetClusterLogs => ({
    type: GET_CLUSTER_LOGS,
    payload,
    callback,
});

export const getClusterDetails = (
    payload: { url: string },
    callback?: Function
): GetClusterDetails => ({
    type: GET_CLUSTER_DETAILS,
    payload,
    callback,
});

export const getPublishedClusterDetails = (
    payload: { id: any, user: any },
    callback?: Function
): GetPublishedClusterDetails => ({
    type: GET_PUBLISHED_CLUSTER_DETAILS,
    payload,
    callback,
});

export const getPublishClusters = (
    payload: { accountID: any, user: any },
    callback: Function
): GetPublishClusters => ({
    type: GET_PUBLISH_CLUSTER,
    payload,
    callback,
});

export const publishClusterData = (
    payload: { accountID: any, params: any, user: any },
    callback: Function
): PublishClusterData => ({
    type: PUBLISH_CLUSTER_DATA,
    payload,
    callback,
});

export const updatePublishedCluster = (
    payload: { accountID: any, params: any, user: any },
    callback: Function
): UpdatePublishedCluster => ({
    type: UPDATE_PUBLISHED_CLUSTER,
    payload,
    callback,
});

export const updateCreativeReplacement = (
    payload: { params: any, user: any },
    callback: Function
): UpdateCreativeReplacement => ({
    type: UPDATE_CREATIVE_REPLACEMENT,
    payload,
    callback,
});

export const updateAdRotation = (
    payload: { params: any, user: any },
    callback: Function
): UpdateAdRotation => ({
    type: UPDATE_AD_ROTATION,
    payload,
    callback,
});

export const setActiveClusterStep = (payload: any): SetActiveClusterStep => ({
    type: SET_ACTIVE_CLUSTER_STEP,
    payload,
});

export const setShowDrawer = (payload: any): SetShowDrawer => ({
    type: SET_SHOW_DRAWER,
    payload,
});

export const setCreateGroupForm = (payload: any): SetCreateGroupForm => ({
    type: SET_CREATE_GROUP_FORM,
    payload,
});

export const setClusterName = (payload: any): SetClusterName => ({
    type: SET_CLUSTER_NAME,
    payload,
});

export const setClusterTable = (payload: any): SetClusterTable => ({
    type: SET_CLUSTER_TABLE,
    payload,
});

export const setPublishCluster = (payload: any): SetPublishCluster => ({
    type: SET_PUBLISH_CLUSTER,
    payload,
});

export const setEditCluster = (payload: any): SetEditCluster => ({
    type: SET_EDIT_CLUSTER,
    payload,
});

export const setSaveCluster = (payload: any): SetSaveCluster => ({
    type: SET_SAVE_CLUSTER,
    payload,
});

export const setCreateAdAdGroup = (payload: any): SetCreateAdAdGroup => ({
    type: SET_CREATEAD_GROUP,
    payload,
});

export const setCreateAdAds = (payload: any): SetCreateAdAds => ({
    type: SET_CREATEAD_ADS,
    payload,
});

export const setClusterKeywords = (payload: any): SetClusterKeywords => ({
    type: SET_CLUSTER_KEYWORDS,
    payload,
});

export const setGetDetails = (payload: any): SetGetDetails => ({
    type: SET_GET_DETAILS,
    payload,
});

export const setHeadlineID = (payload: any): SetHeadlineID => ({
    type: SET_HEADLINE_ID,
    payload,
});

export const setDescriptionID = (payload: any): SetDescriptionID => ({
    type: SET_DESCRIPTION_ID,
    payload,
});

export const setBrand = (payload: any): SetBrand => ({
    type: SET_BRAND,
    payload,
});

export const setClusterLoader = (payload: any): SetClusterLoader => ({
    type: SET_CLUSTER_LOADER,
    payload,
});

export const setGroupsLoader = (payload: any): SetGroupsLoader => ({
    type: SET_GROUPS_LOADER,
    payload,
});

export const setHeaderLoader = (payload: any): SetHeaderLoader => ({
    type: SET_HEADER_LOADER,
    payload,
});

export const setLoadHeadLineDesc = (payload: any): SetLoadHeadLineDesc => ({
    type: SET_LOAD_HEADLINE_DESC,
    payload,
});

export const setDescLoader = (payload: any): SetDescLoader => ({
    type: SET_DESC_LOADER,
    payload,
});

export const setClusters = (payload: any): SetClusters => ({
    type: SET_CLUSTERS,
    payload,
});

export const setClusterDetails = (payload: any): SetClusterDetails => ({
    type: SET_CLUSTER_DETAILS,
    payload,
});

export const setKeyWordsFile = (payload: any): SetKeyWordsFile => ({
    type: SET_KEYWORD_FILE,
    payload,
});

export const setTargetKeyword = (payload: any): SetTargetKeyword => ({
    type: SET_TARGET_KEYWORD,
    payload,
});

export const setCreateAdHeadline = (payload: any): SetCreateAdHeadline => ({
    type: SET_CREATE_AD_HEADLINE,
    payload,
});

export const setCreateAdDesc = (payload: any): SetCreateAdDesc => ({
    type: SET_CREATE_AD_DESC,
    payload,
});

export const setCreateHeadlineParam = (payload: any): SetCreateHeadlineParam => ({
    type: SET_CREATE_HEADLINE_PARAM,
    payload,
});

export const setCreateDescParam = (payload: any): SetCreateDescParam => ({
    type: SET_CREATE_DESC_PARAM,
    payload,
});

export const setPinningPositions = (payload: any): SetPinningPositions => ({
    type: SET_PINNING_POSITIONS,
    payload,
});

export const setCreativeReplacement = (payload: any): SetCreativeReplacement => ({
    type: SET_CREATIVE_REPLACEMENT,
    payload,
});

export const setTimer = (payload: any): SetTimer => ({
    type: SET_TIMER,
    payload,
});

export const setCreateHeadlineError = (
  payload: any
): SetCreateHeadlineError => ({
  type: CREATE_HEADLINE_ERROR,
  payload,
});

export const setCreateDescError = (payload: any): SetCreateDescError => ({
  type: CREATE_DESCRIPTION_ERROR,
  payload,
});

export const setGenerateHeadlineTimestamp = (
  payload: any
): SetGenerateHeadlineTimestamp => ({
  type: GENERATE_HEADLINE_TIMESTAMP,
  payload,
});

export const setGenerateDescriptionTimeStamp = (
  payload: any
): SetGenerateDescriptionTimeStamp => ({
  type: GENERATE_DESCRIPTION_TIMESTAMP,
  payload,
});

export const setGSAIDropdownDisabled =(payload:any):SetGSAIDropdownDisabled =>({
    type: GSAI_DROPDOWN_DISABLED,
    payload,
  });